// Thunk for async actions related to soft tags
import { createAsyncThunk } from '@reduxjs/toolkit';
import type { CreateSoftTagParams, EditSoftTagParams, ValidateCodeParams } from '../utils/types';
import { createSoftTagApi, editSoftTagApi, validateCodeApi } from '../api/createTag.api';

export const createSoftTag = createAsyncThunk(
  'Tags/createSoftTag',
  async (params: CreateSoftTagParams | undefined, thunkAPI) => {
    try {
      const response = await createSoftTagApi(params);
      return response;
    } catch (e) {
      // Return error if API call fails
      return thunkAPI.rejectWithValue(e);
    }
  }
);

export const editSoftTag = createAsyncThunk(
  'Tags/editSoftTag',
  async (params: EditSoftTagParams | undefined, thunkAPI) => {
    try {
      const response = await editSoftTagApi(params);
      return response;
    } catch (e) {
      // Return error if API call fails
      return thunkAPI.rejectWithValue(e);
    }
  }
);

export const validateCode = createAsyncThunk(
  'Tags/validateCode',
  async (params: ValidateCodeParams, thunkAPI) => {
    try {
      const response = await validateCodeApi(params);
      return response;
    } catch (e) {
      // Return error if API call fails
      return thunkAPI.rejectWithValue(e);
    }
  }
);
